module.exports = {"zh":{"health_warning":["抵制不良游戏 拒绝盗版游戏","注意自我保护 谨防受骗上当","适度游戏益脑 沉迷游戏伤身","合理安排时间 享受健康生活","本游戏适合15周岁以上人群"],"reference":["新出审字[0123]012号","ISBN 012-0-01234-012-0","电出字01-0123-012","文网进字[0123]012号"]}}


//////////////////
// WEBPACK FOOTER
// ./src/components/LegalTexts/legal-texts.json
// module id = 1074
// module chunks = 0